import { axios } from '@/axios.config';
import { mockAdapter } from '@/mocks/axiosMockAdapter.config';
import { sortObject } from '@/lib/sorter';

export const state = {
  crossTags: {
    data: [],
    loading: false,
    error: null,
  },
  selectedId: null,
};

export const actions = {
  /**
   * Fetch cross tag list
   * @param commit
   * @returns {Promise}
   */
  fetchCrossTags({ state, commit }, { force = false }) {
    if (!force) {
      if (state.crossTags.data.length) return Promise.resolve();
    }

    const vendor = 'aws';
    const url = `/crosstag/vendor/${vendor}`;

    mockAdapter(axios, 'get', url, 'getCrossTags', 200);

    commit('requestStart', { key: 'crossTags' });
    return axios
      .get(url)
      .then(res => {
        const data = res.data;
        commit('requestSucceed', { key: 'crossTags' });
        commit('updateCrossTags', data);
      })
      .catch(err => {
        commit('requestFailed', { key: 'crossTags' });
        throw err;
      });
  },

  /**
   * Cross tag detail.
   * No use API for fetch.
   * @param state
   * @param commit
   * @return {Promise}
   */
  fetchCrossTagDetail({ state, commit, rootState }) {
    const id = rootState.usageReports.id;

    const target = state.crossTags.data.find(i => i.id === id);
    if (!target) return Promise.reject('No detail');

    commit('usageReports/updateDetail', { data: target, reqHash: id }, { root: true });

    return Promise.resolve();
  },
};

export const mutations = {
  requestStart(state, { key }) {
    state[key]['loading'] = true;
    state[key]['error'] = null;
  },

  requestSucceed(state, { key }) {
    state[key]['loading'] = false;
  },

  requestFailed(state, { key }) {
    state[key]['loading'] = false;
    state[key]['error'] = true;
  },

  updateCrossTags(state, data) {
    const converted = data.map(item => {
      let mainTagKey = '';
      let mainTagValue = '';

      if (item.tags.length > 0) {
        mainTagKey = item.tags[0]['key'];
        mainTagValue = item.tags[0]['value'];
      }

      return {
        account_id: item.account_id,
        id: item.id,
        tags: item.tags,
        mainTagKey: mainTagKey,
        mainTagValue: mainTagValue,
        multipleTags: item.tags.length > 1,
      };
    });

    // Add nontag at the end.
    converted.push({
      account_id: 'nontag',
      id: 'nontag',
      tags: [],
      mainTagKey: 'Nontag',
      mainTagValue: 'Nontag',
      multipleTags: false,
    });

    state.crossTags.data = sortObject(converted, 'mainTagKey');
  },

  updateCrossTagDetail(state, data) {
    state.detail.data = data;
  },

  updateSelectedId(state, id) {
    state.selectedId = id;
  },
};

export const getters = {
  /**
   * Cross tagリストの各アイテムに 'mainTagKey', 'mainTagValue', 'multipleTags' を追加する。
   * @param state
   * @return {Array}
   * Sorted
   */
  getCrossTags(state) {
    if (!state.crossTags.data) return [];

    return state.crossTags.data;
  },

  /**
   * Return Cross tag detail > tags
   * @param state
   * @return {array}
   */
  getCrossTagDetailTags(state) {
    const id = state.selectedId;
    if (!id) return [];

    const target = state.crossTags.data.find(item => item.id === id);

    return target ? target.tags : [];
  },
};
